import { CustomizedDxColumn } from '..';
import { ComboBox } from '../../../../..';
import { ISetCellValueChangeEventArgs } from '../../../../../entities/EventArgs';

export async function setCellValue(this: CustomizedDxColumn, newData, value, currentRowData) {
	const args: ISetCellValueChangeEventArgs = {
		columnName: this.name,
		newData,
		value,
		currentRowData
	};

	args.newData[this.name] = args.value;

	const dataGrid = this.retrieveDataGridInstance();

	dataGrid.columns.forEach(bcColumn => {
		if (bcColumn.editType === 'comboBox') {
			const control = bcColumn.editControl as ComboBox;

			if (control.dataSource.name) {
				control.dataSource.parameters.forEach(param => {
					if (
						param.valueModifier == 'fieldSelection' &&
						param.field.includes(`columns.${this.name}.`)
					) {
						args.newData[bcColumn.name] = null;
					}
				});
			}
		}
	});

	await dataGrid.emit('event:SetCellValue', args);
}
